import {
  FieldValues,
  FormProvider,
  SubmitHandler,
  UseFormReturn,
} from 'react-hook-form';
import { FocusEventHandler, ReactNode } from 'react';

interface Props<T extends FieldValues> {
  children: ReactNode;
  form: UseFormReturn<T>;
  className?: string;
  onSubmit: SubmitHandler<T>;
  onBeforeSubmit?: () => void;
  onBlur?: FocusEventHandler<HTMLFormElement>;
  id?: string;
}

export function Form<T extends FieldValues>({
  children,
  onBeforeSubmit,
  onSubmit,
  form,
  className,
  id,
  onBlur,
}: Props<T>) {
  return (
    <FormProvider {...form}>
      <form
        id={id}
        onBlur={(e) => {
          console.log("Form field blurred:", e.target.name, "with value:", e.target.value);
          onBlur?.(e);
        }}
        className={className}
        onSubmit={(e) => {
          console.log("Form submission initiated");
          e.stopPropagation();
          if (onBeforeSubmit) {
            console.log("Running onBeforeSubmit");
            onBeforeSubmit();
          }
          form.handleSubmit(onSubmit)(e)
            .then(() => console.log("handleSubmit executed successfully"))
            .catch((err) => console.error("Error during handleSubmit:", err));
        }}
      >
        {children}
      </form>
    </FormProvider>
  );
}
